<template>
    <div class="">
        <div class="row no-gutters py-3">
            <div class="col-sm-6 pr-5 pl-4 company-form-box-title">Employee Signature</div>
            <template>
                <div class="col-sm-6 px-3 ">
                    <button @click="addNew()" class="cursor-pointer edit-icon">
                        <template v-if="paginatedData.length > 0">
                            <i class="fa fa-pencil-alt"></i>
                        </template>
                        <template v-else>
                            <i class="fa fa-plus"></i>
                        </template>

                    </button>

                    <template v-if="paginatedData.length > 0">
                        <button @click="deleteSignatureModal()" class="cursor-pointer edit-icon">
                            <i class="fa fa-trash"></i></button>
                    </template>

                </div>

            </template>
        </div>
        <div class="row no-margin">
            <div class="col-md-12 px-4 pb-4">
                <div class="signature-wrapper border rounded py-4" v-for="(signatory, n) in paginatedData"
                    :key="signatory.id">
                    <img v-bind:src="$api_url + '/images/company/signature/employee/' + signatory.signature" width="200">
                </div>
            </div>
        </div>

        <b-modal id="bv-modal-signatory" :modal-class="'w-600'" size="lg" hide-footer title="Employee Signature">
            <b-overlay :show="showoverlay" rounded="sm">

                <b-form @submit.stop.prevent="onSubmit" class="" :key="fkey">
                    <div class="clearfix">
                        <div id="signature-group" role="group" class="form-group row">
                            <div class="col-md-12">
                                <div class="custom-control">
                                    <input type="radio" id="signatory_manual" class="custom-control-input"
                                        name="signatory_upload_type" value="1" v-model="signatory_upload_type" />
                                    <label class="custom-control-label" for="__BVID__239">Upload Signature </label>
                                </div>

                                <div class="custom-control">
                                    <input type="radio" id="signatory_employee" class="custom-control-input"
                                        name="signatory_upload_type" value="0" v-model="signatory_upload_type" />
                                    <label class="custom-control-label" for="__BVID__239">Use Signature Pad</label>
                                </div>
                                <div class="bv-no-focus-ring mt-4" style="display:block;"
                                    v-if="signatory_upload_type == 1">
                                    <b-form-group id="form_employee_signature-group" label="Upload Signature"
                                        label-for="form_employee_signature">
                                        <b-form-file id="form_employee_signature" v-model="form_employee_signature"
                                            @change="checkFileType($event, 'form_employee_signature', ['.jpg', '.png'])"
                                            ref="form_employee_signature" accept=".jpg, .png"
                                            placeholder="Choose a file or drop it here..."
                                            drop-placeholder="Drop file here..."
                                            aria-describedby="form_employee_signature-feedback"
                                            data-vv-as="Upload Signature"></b-form-file>
                                    </b-form-group>
                                </div>
                                <div class="mt-4" v-else>
                                    <label id="signature-group__BV_label_" for="signature" class="d-block">Use Signature
                                        Pad</label>
                                    <div class="border" style="height: 150px;">
                                        <VueSignaturePad height="150px" ref="signaturePad"
                                            :options="{ onBegin: () => { $refs.signaturePad.resizeCanvas() } }"
                                            style="background: #eee;" />
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div class="row signature-modal-main-mobile">

                            <div class="col-md-6 text-right signature-modal-button-mobile">
                                <b-button variant="primary" @click="undoSignaturePad" style="">Reset</b-button>
                            </div>
                            <div class="col-md-6 signature-modal-button-mobile">
                                <b-button type="submit" variant="primary" style="">Save</b-button>
                            </div>


                        </div>
                    </div>
                </b-form>
            </b-overlay>
        </b-modal>
        <b-modal id="bv-signature-modal" title="Are you sure you want to delete this Signature ?" hide-footer>
            <br />
            <div style="height: 10px;clear:both;"> &nbsp;</div>
            <a href="javascript:void(0);" class="btn btn-primary btn-full-width"
                @click="deleteSignature(signature_id)">Delete
                <span v-if="loading != ''"><img :src="$api_url + '/images/loading.gif'" width="20"></span></a>
            &nbsp;&nbsp; <a href="javascript:void(0);" class="btn btn-primary btn-full-width" block
                @click="$bvModal.hide('bv-signature-modal')">Cancel</a>
            <div style="height: 5px;clear:both;"> &nbsp;</div>
        </b-modal>

    </div>
</template>


<script>
import Vue from 'vue';
import myUpload from 'vue-image-crop-upload';
import VueSignaturePad from 'vue-signature-pad';
Vue.use(VueSignaturePad);
export default {
    name: 'MySignaturePad',
    mounted() {
        if (this.check_ce == 1) {
            if (this.ce_flg == 1)
                this.ce = true;
            else
                this.ce = false;


        }
    },
    props: ['ce_flg', 'check_ce'],
    components: { 'my-upload': myUpload },
    data() {

        return {

            signatories: [],
            manager: [],
            employeeSearch:
            {
                name: "",
            },

            showoverlay: false,
            showoverlay_list: false,
            movenext: false,

            errormsg: [],
            fdata: { id: null, name: '', designation: '' },
            signatory_type: 1,
            signatory_upload_type: 1,

            search: '',
            length: 20,
            pagination: { currentPage: 1, pages: 1 },

            ce: true,

            logoUrl: '',
            logoUploaded: false,
            showLogoUploader: false,
            fkey: 0,
            form_employee_signature: null,
            loading: false,
            signature_id: null,
        }
    },
    methods: {

        undoSignaturePad() {
            this.$refs.signaturePad.clearSignature();
        },

        saveSignaturePad() {
            const { isEmpty, data } = this.$refs.signaturePad.saveSignature();

        },

        deleteSignatureModal() {
            this.$bvModal.show('bv-signature-modal');
        },
        deleteSignature(id) {
            let formData = new FormData();
            formData.append('id', id);

            axios.post(this.$api_url + '/front/employee/signatory/delete', formData).then(function (response) {
                console.log('response.data.meg: ' + response.data.meg);
                if (response.data.meg == 'Successfully deleted.') {
                    console.log('response.data.meg: ' + response.data.meg);
                    this.$bvToast.toast(response.data.meg, {
                        title: `Success`,
                        variant: 'success',
                        solid: true
                    });
                    // this.signatories = response.data.signatories;

                    // this.$forceUpdate();
                    // this.$emit('signaureUpdated');

                }
                else {
                    this.$bvToast.toast(response.data.meg, {
                        title: `Warning`,
                        variant: 'warning',
                        solid: true
                    });
                }

                this.$bvModal.hide('bv-signature-modal');
                this.getSignatories();


            }.bind(this))
                .catch(function (error) {
                    currentObj.showoverlay_list = false;
                    currentObj.showoverlay = false;
                    currentObj.serverError(error);
                });
        },
        toggleLogoUploader() {
            this.showLogoUploader = !this.showLogoUploader;
        },
        cropSuccess(imgDataUrl, field) {

            this.logoUrl = imgDataUrl;
            this.logoUploaded = true;
        },


        getSignatories: function () {
            if (!this.checkNet()) return false;
            let currentObj = this;




            axios.get(this.$api_url + '/front/employee/signatory', {
                params: {
                    //employee_id: this.employeeId
                }
            }).then(function (response) {
                this.signatories = response.data;


                currentObj.signature_id = null;

                currentObj.signatories.forEach(function (item) {
                    currentObj.signature_id = item.id;
                });



            }.bind(this)).catch(function (error) { currentObj.serverError(error); });
        },
        editSignatory: function (x) {
            if (!this.checkNet()) return false;
            let currentObj = this;

            //this.showoverlay = true;
            axios.get(this.$api_url + '/front/signatory/details', {
                params: {
                    id: x
                }
            }).then(function (response) {
                this.fdata = response.data;
                if (response.data.signature != "") {
                    this.logoUrl = this.$api_url + '/images/company/signature/' + response.data.signature;
                    currentObj.signatory_upload_type = 1;
                }
                else
                    currentObj.signatory_upload_type = 2;

                this.$validator.reset();

                this.$bvModal.show('bv-modal-signatory');

            }.bind(this)).catch(function (error) { currentObj.showoverlay = false; currentObj.serverError(error); });

        },
        deleteSignatory(id) {
            if (!this.checkNet()) return false;
            let currentObj = this;

            this.$bvModal.msgBoxConfirm('Please confirm that you want to delete this signatory.', {
                title: 'Please Confirm', size: 'sm', buttonSize: 'sm', okVariant: 'primary', okTitle: 'Yes', cancelTitle: 'Cancel', footerClass: 'p-2', hideHeaderClose: false, centered: true
            })
                .then(value => {
                    if (value) {

                        this.showoverlay_list = true;
                        let formData = new FormData();
                        formData.append('id', id);

                        axios.post(this.$api_url + '/front/signatory/delete', formData).then(function (response) {

                            if (response.data.status == true) {
                                this.$bvToast.toast(response.data.meg, {
                                    title: `Success`,
                                    variant: 'success',
                                    solid: true
                                });
                                this.signatories = response.data.signatories;

                            }
                            else {
                                this.$bvToast.toast(response.data.meg, {
                                    title: `Warning`,
                                    variant: 'warning',
                                    solid: true
                                });
                            }

                            this.resetPagination();
                            this.showoverlay_list = false;
                            this.showoverlay = false;

                        }.bind(this))
                            .catch(function (error) {
                                currentObj.showoverlay_list = false;
                                currentObj.showoverlay = false;
                                currentObj.serverError(error);
                            });
                    }
                })
                ;
        },
        validateState(ref) {
            if (
                this.veeFields[ref] &&
                (this.veeFields[ref].dirty || this.veeFields[ref].validated)
            ) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        resetForm() {
            this.fdata = { id: null, name: '', designation: '' };
            this.signatory_type = 1;
            this.signatory_upload_type = 1,
                this.logoUrl = '';



            this.$nextTick(() => {
                this.$validator.reset();
            });
        },
        addNew() {
            this.resetForm();
            this.$bvModal.show('bv-modal-signatory');
        },
        onSubmit(e) {
            if (!this.checkNet()) return false;
            this.warningmsg = null;
            this.successmsg = null;


            this.$validator.validateAll().then(result => {
                if (!result) {
                    return;
                }
                //this.showoverlay = true;

                e.preventDefault();
                let currentObj = this;
                const config = {
                    headers: { 'content-type': 'multipart/form-data' }
                }

                let formData = new FormData();

                if (parseInt(currentObj.signatory_upload_type) == 1) {
                    if (this.form_employee_signature)
                        formData.append('signature_image', this.form_employee_signature);

                    if (this.form_employee_signature == null) {
                        this.$bvToast.toast('Please upload your signature or close the form.', {
                            title: `No File Attached`,
                            variant: 'info',
                            solid: true
                        });
                        return 0;
                    }


                }
                else if (parseInt(currentObj.signatory_upload_type) != 2) {
                    const { isEmpty, data } = currentObj.$refs.signaturePad.saveSignature();
                    if (!isEmpty) {
                        formData.append('signature_pad', data);

                    }
                    else {

                        this.$bvToast.toast('Please add your signature or close the form.', {
                            title: `No Signature Added`,
                            variant: 'info',
                            solid: true
                        });
                        return 0;



                    }

                }



                formData.append('signatory_upload_type', currentObj.signatory_upload_type);



                //currentObj.saveSignaturePad();


                //console.log(data);

                axios.post(this.$api_url + '/front/employee/signatory/save', formData, config)
                    .then(function (response) {
                        //console.log(response.data);
                        this.signatories = response.data;
                        this.$forceUpdate();
                        this.$emit('signaureUpdated');

                        this.$bvToast.toast('Saved!', {
                            title: `Success`,
                            variant: 'success',
                            solid: true
                        });

                        this.showoverlay_list = false;
                        this.showoverlay = false;
                        this.resetForm();
                        //this.movenext = true;

                        this.$bvModal.hide('bv-modal-signatory');

                    }.bind(this))
                    .catch(function (error) {
                        this.showoverlay_list = false;
                        this.showoverlay = false;

                        currentObj.serverError(error);
                        currentObj.errormsg = error.response.data.errors;
                    });
            });
        },

    },
    created: function () {
        this.getSignatories();
        //this.initSignaturePad();

        Fire.$on('reloadUsers', () => { this.getSignatories() });
    },
    computed:
    {

        filteredData() {

            let filtered_list = this.signatories;

            if (this.search) {
                filtered_list = filtered_list.filter((row) => { return Object.keys(row).some((key) => { return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1; }) });
            }

            return filtered_list;
        },
        paginatedData() {
            return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
        },

        filteredItems() {
            if (this.employeeSearch.name.trim().length === 0) {
                return this.manager;
            }
            return this.manager.filter(item => item.text.toLowerCase().indexOf(this.employeeSearch.name.toLowerCase()) > -1)
        }

    }
}

</script>
<style></style>
